// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { orderStatusCode } from 'Utils/constants';
import { awOrange } from 'Utils/themes';

export type PinStatusKind = 'inProgress' | 'delivered' | 'canceled' | 'estimate' | 'notSubmitted';

export interface IPinStatusChip {
  label: string;
  kind: PinStatusKind;
}

// The card's status chip, in the mockup's customer-facing terms: everything between placement
// and delivery reads as one "In Progress" state - the internal drafting/QC codes are ops detail.
export const getPinStatusChip = (project: { orderStatus?: number; isEstimate?: boolean }): IPinStatusChip => {
  if (project.isEstimate) return { label: 'Estimate', kind: 'estimate' };
  if (project.orderStatus === undefined || project.orderStatus === null || project.orderStatus === orderStatusCode.created) {
    // A created order is a cart that was never placed - same story as no order at all.
    return { label: 'Not submitted', kind: 'notSubmitted' };
  }
  if (project.orderStatus === orderStatusCode.done) return { label: 'Completed', kind: 'delivered' };
  if (project.orderStatus === orderStatusCode.canceled) return { label: 'Canceled', kind: 'canceled' };
  return { label: 'In Progress', kind: 'inProgress' };
};

// One dot-color source for every surface that renders a pin status (rail cards, map popup):
// the Figma pairs "Completed" with a green dot; in-progress reads accent blue.
export const getStatusDotColor = (theme: any, kind: PinStatusKind): string => {
  const dotColors: Record<PinStatusKind, string> = {
    delivered: theme.palette.success.main,
    inProgress: theme.palette.primary.main,
    estimate: awOrange,
    canceled: theme.palette.darkGrey,
    notSubmitted: theme.palette.darkGrey,
  };
  return dotColors[kind];
};
